const API_URL = process.env.API_URL
const API_URL_CLIENT = process.env.API_URL_CLIENT || API_URL
const MENU_ENDPOINT = process.env.MENU_ENDPOINT
const MENU_ENDPOINT_CLIENT = process.env.MENU_ENDPOINT_CLIENT || MENU_ENDPOINT
const FOOTER_ENDPOINT = process.env.FOOTER_ENDPOINT
const FOOTER_ENDPOINT_CLIENT =
  process.env.FOOTER_ENDPOINT_CLIENT || FOOTER_ENDPOINT
const MOCK_MENUS = process.env.MOCK_MENUS === 'true' ? true : false
const GRAPH_API_URL = process.env.GRAPH_API_URL || `${API_URL}/graphql`
const GRAPH_API_URL_CLIENT =
  process.env.GRAPH_API_URL_CLIENT || `${API_URL_CLIENT}/graphql`
const BACKEND_URL = process.env.BACKEND_URL
const UPLOAD_ENDPOINT = `${API_URL}/api/image/upload`
const UPLOAD_ENDPOINT_CLIENT = `${API_URL_CLIENT}/api/image/upload`
const API_BASIC_AUTH =
  String(process.env.API_BASIC_AUTH) === '1' ||
  String(process.env.API_BASIC_AUTH) === 'false' ||
  false

const IS_SERVER = typeof window === 'undefined'

export default {
  DEBUG: false,
  API_URL: !IS_SERVER ? API_URL_CLIENT : API_URL,
  MOCK_MENUS,
  MENU_ENDPOINT: !IS_SERVER ? MENU_ENDPOINT_CLIENT : MENU_ENDPOINT,
  FOOTER_ENDPOINT: !IS_SERVER ? FOOTER_ENDPOINT_CLIENT : FOOTER_ENDPOINT,
  GRAPH_API_URL: !IS_SERVER ? GRAPH_API_URL_CLIENT : GRAPH_API_URL,
  UPLOAD_ENDPOINT: !IS_SERVER ? UPLOAD_ENDPOINT_CLIENT : UPLOAD_ENDPOINT,
  BACKEND_URL,
  API_BASIC_AUTH,
}
